module.exports = __webpack_public_path__ + "static/img/tu-1.56a94e2c.png";